import { Field } from '../../AddBeneficiaryPopup.types';
import { Item, ItemHeader, ItemText } from './StepFour.styles';

export const getMiscKeys = (keysExclude: string[], fields: Field[]) =>
    fields.reduce<string[]>((acc, field) => {
        if (!keysExclude.includes(field.path)) {
            acc.push(field.path);
        }

        return acc;
    }, []);

export const mapKeysToElements = (keys: string[], formValues: Record<string, string>, fields: Field[]) =>
    keys.map((key) => {
        const field = fields.find((field) => field.path === key && field.enabled);

        if (!field) {
            return null;
        }

        return (
            <Item key={key}>
                <ItemHeader>{field.field.label}</ItemHeader>

                <ItemText>{formValues[key] || '-'}</ItemText>
            </Item>
        );
    });
